<template>
    <v-layout justify-center>
        <v-responsive max-width="1240" width="100%" class="px-3 mx-n3">
            <list-heading title="신용카드 거래 목록" showsFilterButton v-model="showsSearch" />
            <point-order-list-search v-bind="{ showsSearch }" />
            <point-order-list-filter />

            <v-data-table v-bind="{ items, headers, loading }" :items-per-page="-1" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined mt-3">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>

                <template #[`item.paymentAmount`]="{ item, value }">
                    <point-order-point-btn :value="item">
                        <span> {{ value?.format?.() || value || 0 }}원 </span>
                    </point-order-point-btn>
                </template>
                <template #[`item.state`]="{ item, value }">
                    <point-order-state-edit :value="item" v-on="{ update }">
                        <v-btn text tile block class="caption justify-start">{{ USER_POINT_ORDER_STATES[value]?.text }}</v-btn>
                    </point-order-state-edit>
                </template>
                <template #[`item.memo`]="{ item, value }">
                    <point-order-memo-edit :value="item" v-on="{ update }">
                        <v-btn text tile block class="caption memo-area">{{ value || "-" }}</v-btn>
                    </point-order-memo-edit>
                </template>
            </v-data-table>

            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_input, USER_POINT_ORDER_STATES, USER_TYPES } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import PointOrderPointBtn from "@/components/console/users/point-orders/point-order-point-btn.vue";
import PointOrderMemoEdit from "@/components/console/users/point-orders/point-order-memo-edit.vue";
import PointOrderStateEdit from "@/components/console/users/point-orders/point-order-state-edit.vue";
import PointOrderListSearch from "@/components/console/users/point-orders/point-order-list-search.vue";
import PointOrderListFilter from "@/components/console/users/point-orders/point-order-list-filter.vue";

const headers = [
    { width: 100, text: "결제일시", value: "createdAt", formatter: (value) => value?.toDateTime?.() || value || "-" },
    { width: 180, text: "주문번호", value: "orderNo" },
    { width: 140, text: "사용자", value: "buyer", formatter: ({ username, name, phone } = {}) => [username, name, phone].filter((item) => item).join("\n") },
    { width: 100, text: "결제금액", value: "paymentAmount", cellClass: "px-0" },
    { width: 100, text: "거래유형", value: "paymentMethod" },
    { width: 100, text: "PG", value: "paymentGateway" },
    { width: 100, text: "거래상태", value: "state", cellClass: "px-0" },
    { width: 300, text: "메모", value: "memo", cellClass: "px-0" },
].map((item, index, array) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-"), divider: index != array.length - 1, class: (item.class || "") + " white-space-pre-line", cellClass: (item.cellClass || "") + " caption line-height-1-5 white-space-pre-line py-2" }));

const userTypes = [USER_TYPES.COMPANY.value];

export default {
    components: {
        ListHeading,
        PointOrderPointBtn,
        PointOrderMemoEdit,
        PointOrderStateEdit,
        PointOrderListSearch,
        PointOrderListFilter,
    },
    data: () => ({
        orders: [],

        limit: 20,
        summary: { totalCount: 0 },

        headers,

        loading: false,
        showsSearch: true,

        attrs_input,

        userTypes,
        USER_POINT_ORDER_STATES,
    }),
    computed: {
        items() {
            return [...this.orders];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                await this.search(false);
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, orders } = await api.console.users.points.orders.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.orders = orders;
            } finally {
                this.loading = false;
            }
        },

        async update(order) {
            if (this.loading) return;
            else this.loading = true;

            try {
                order = (await api.console.users.points.orders.put(order))?.order;
                alert("저장되었습니다");
                this.updateItem(order);
            } finally {
                this.loading = false;
                this.search();
            }
        },

        updateItem(order) {
            const index = this.orders.findIndex(({ _id }) => _id == order._id);
            if (0 <= index) this.orders.splice(index, 1, order);
            else {
                this.orders = [order, ...this.orders];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    .memo-area {
        height: auto !important;

        .v-btn__content {
            display: block;
            text-align: initial;
            white-space: pre-line;
            text-transform: initial;
        }
    }
}
</style>
